let $body, scrollPosition;

// function bodyFixedOn() {
// 	scrollPosition = window.pageYOffset;
// 	$body.style.position = 'fixed';
// 	$body.style.top = `-${scrollPosition}px`;
// }

// function bodyFixedOff() {
// 	$body.style.removeProperty('position');
// 	$body.style.removeProperty('top');
// 	window.scrollTo(0, scrollPosition);
// }

function scrollTop() {
	const $pageTop = document.querySelector('.page-top__btn');
	$pageTop.onclick = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	}
}

function scrEffect() {
	const $view_class = document.querySelectorAll('[data-scview]');
	const view_fadeArray = Array.prototype.slice.call($view_class, 0);
	const $ac_view = 'is-inview';

	if ($view_class.length) {
		const opt_view = {
			root: null,
			rootMargin: '0px 0px -15%',
			threshold: 0
		};
		const observer_view = new IntersectionObserver(is_viewFunc, opt_view);
		view_fadeArray.forEach(function (view) {
			observer_view.observe(view);
		});

		function is_viewFunc(entries) {
			const entriesArray = Array.prototype.slice.call(entries, 0);
			entriesArray.forEach(function (entry) {
				if (entry.isIntersecting) {
					entry.target.classList.add($ac_view);
				}
			});
		}

	}
}

function ready() {
	$body.classList.add('is-loaded');
	scrollTop();
	scrEffect();
}

if (document.readyState !== 'loading') {
	$body = document.body;
	ready();
} else {
	window.addEventListener('DOMContentLoaded', function () {
		$body = document.body;
		ready();
	});
}
